import React from 'react';
import { Button } from '@syneto/compass-react';
import { COMPLIANCE_VERDICT_STATUS_FILTERS } from '../../../../constants/compliance-verdicts';

/*
 * The page lists every appliance until a serial is searched for; searching a blank serial goes back
 * to every appliance.
 *
 * Deliberately a submit-driven search with no debounce. `serialNumber` is an exact server-side
 * match, so a debounced read would fire once per prefix and every one of them would come back
 * empty - rendering "no verdicts for SN-1" mid-keystroke, on a page whose job includes answering
 * "is this appliance exempt?". A transient false negative is the worst failure mode available here.
 */
const ComplianceVerdictsSearchBar = (props) => {
	const {
		serialInput,
		committedSerialNumber,
		status,
		isLoading,
		isSaving,
		canCreate,
		onSerialInputChange,
		onSearch,
		onStatusChange,
		onCreate
	} = props;

	const handleSubmit = (event) => {
		event.preventDefault();
		onSearch();
	};

	return (
		<div className="mb-3">
			<form className="d-flex justify-content-between align-items-center gap-2" onSubmit={handleSubmit}>
				<div className="d-flex align-items-center gap-2">
					<label className="mb-0" htmlFor="compliance-verdict-serial">Serial number</label>

					<input
						id="compliance-verdict-serial"
						className="form-control"
						style={{ maxWidth: '260px' }}
						value={serialInput}
						placeholder="Appliance serial number"
						onChange={(event) => { return onSerialInputChange(event.target.value); }}
					/>

					<Button type="submit" disabled={isLoading}>Search</Button>

					<select
						className="form-select"
						style={{ maxWidth: '150px' }}
						value={status}
						aria-label="Verdict status"
						onChange={(event) => { return onStatusChange(event.target.value); }}
					>
						{COMPLIANCE_VERDICT_STATUS_FILTERS.map((filter) => {
							return <option key={filter.label} value={filter.value}>{filter.label}</option>;
						})}
					</select>
				</div>

				{/*
				  * Creates an override that has no failed check behind it. Granting one on a failed
				  * check is the row action in the table, which keeps the "Grant override" label the
				  * ticket asks for - so this one says Create, and the two cannot be mistaken.
				  */}
				<Button disabled={isSaving || !canCreate} onClick={() => { return onCreate(); }}>Create override</Button>
			</form>

			{/*
			  * Bound to the committed serial, never to the input. Editing the box without searching
			  * must not change what the table claims to be showing.
			  */}
			{committedSerialNumber && (
				<p className="text-muted mt-2 mb-0">
					Compliance verdicts for <span className="text-value">{committedSerialNumber}</span>
				</p>
			)}
		</div>
	);
};

export default ComplianceVerdictsSearchBar;
